
import FetchApi from "../../../../customhooks/functionFetchApi"
const FetchApis =new FetchApi();

export function getProductbyjournal(jourId,newJourId){
        FetchApis.FethcGet(`/productcolor/getproductByjournal/${jourId}`).then(res=>{
            if(res){
                var dataall=res.data.data;
                for (let index = 0; index < dataall.length; index++) {
                    const productcolorlist = dataall[index];
                    CreateProductcolor(productcolorlist,newJourId);

                }
            }
        })
}

function CreateProductcolor(productlist,newJourId){
   
    var dataobjec={
         number:productlist.number,
         colorname:productlist.colorname, 
         remark:productlist.remark, 
         journalId:newJourId
    }
    FetchApis.FethcPost(`/productcolor/createcolor`,dataobjec).then(res=>{
        if(res){
            var newcolorid=res.insertId
            Getcolordetial(newcolorid,productlist.colorId,newJourId)
        }
    })
}

function Getcolordetial(newcolorid,colorId,newJourId){
    FetchApis.FethcGet(`/productcolordetail/getproductByColorId/${colorId}`).then(res=>{
        if(res){
           
            var dataall=res.data.data;
            for (let index = 0; index < dataall.length; index++) {
                const colorlist = dataall[index];
                    CreateColordetail(colorlist,newcolorid,newJourId)
            }
        }
    })
}

function CreateColordetail(colorlist,newcolorid,newJourId){
    var datalistcolor={
        inkname:colorlist.inkname,
         formulate:colorlist.formulate, 
         kg1:colorlist.kg1, 
         kg2:colorlist.kg2,
         formulate_params:colorlist.formulate_params,
         Kg_params:colorlist.formulate_params, 
         colorId:newcolorid,
         journalId:newJourId
    }

    FetchApis.FethcPost(`/productcolordetail/createcolor`,datalistcolor).then(res=>{
        if(res){
         
        }
    })  
}